import { render, staticRenderFns } from "./baseasignaciones.vue?vue&type=template&id=6d4ab028"
import script from "./baseasignaciones.vue?vue&type=script&lang=js"
export * from "./baseasignaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports